import client from "./client";

export const fetchCountryById = async (id: number) => {
  const response = await client.get(`/country/${id}`);
  return response.data;
};
